module.exports = __webpack_public_path__ + "img/vertical_5_1_8023.a04180f5.png";